import { storage } from "@gtmhub/core/storage";

export const getCurrentUserId = (): string => storage.get("userId");

export const setCurrentUserId = (id: string): void => {
  storage.set("userId", id);
};

export const getCurrentUserRoles = (): string[] => storage.get("roles") || [];

export const setCurrentUserRoles = (roles: string[]): void => storage.set("roles", roles);

export const hasCurrentUserRole = (roleName: string): boolean => getCurrentUserRoles().indexOf(roleName) !== -1;
